var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.13 62.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #ffc139;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.55px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #ffeed3;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n        stroke-width: 1.04px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 0,
    width: 62.13,
    height: 62.13,
    rx: 16.57,
    ry: 16.57,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.52,
    y: 0.52,
    width: 61.09,
    height: 61.09,
    rx: 16.05,
    ry: 16.05,
    shapeRendering: "crispEdges"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.64,34.17v-13.98s0-3.11,3.11-3.11h9.32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.31,31.84l2.33,2.33,2.33-2.33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.06,21.75v18.64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.72,24.08h-8.54c-.78,0-2.33.47-2.33,2.33v2.33c0,.78.47,2.33,2.33,2.33h6.99c.78,0,2.33.47,2.33,2.33v2.33c0,.78-.47,2.33-2.33,2.33h-8.54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.49,27.96v13.98s0,3.11-3.11,3.11h-9.32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.82,30.29l-2.33-2.33-2.33,2.33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransfer);
export default __webpack_public_path__ + "static/media/icon-transfer.d666202ffda006ec8b0b7e5a60e3aae3.svg";
export { ForwardRef as ReactComponent };